import type { RefObject } from 'react';
import { useEffect } from 'react';
import { select } from 'd3-selection';

/**
 * d3 で mousemoveのコールバックを利用するためのフック
 * @param ref mousemoveイベントを受け取りたいHTML/SVG要素のref
 * @param onMouseMove イベントハンドラ
 * @param stopPropagation イベント伝搬を停止するか否かを決めるbool値
 */
export const useD3MouseMoveCallback = <T extends HTMLElement | SVGElement>(
  ref: RefObject<T | null>,
  onMouseMove: (event: MouseEvent) => void,
  stopPropagation = false
): void => {
  useEffect(() => {
    const dom = ref.current;
    select(dom).on('mousemove', (event: MouseEvent) => {
      if (stopPropagation) {
        event.stopPropagation();
      }
      onMouseMove(event);
    });

    return () => {
      select(dom).on('mousemove', null);
    };
  }, [ref, onMouseMove, stopPropagation]);
};
